// Display data for the site languages (the codes themselves are configured in gatsby-config.js).
// `name` is the language's name in that language; `title` is the word "Language" in it, used for
// the selector's popup heading in the current language - the aspose.ai bar is outside the i18next
// provider (see wrap-page-element.js), so it cannot read the locale files.
const languages = {
    en: {name: "English", title: "Language"},
    ar: {name: "العربية", title: "اللغة"},
    zh: {name: "简体中文", title: "语言"},
    nl: {name: "Nederlands", title: "Taal"},
    fr: {name: "Français", title: "Langue"},
    de: {name: "Deutsch", title: "Sprache"},
    hi: {name: "हिन्दी", title: "भाषा"},
    id: {name: "Bahasa Indonesia", title: "Bahasa"},
    it: {name: "Italiano", title: "Lingua"},
    ja: {name: "日本語", title: "言語"},
    ko: {name: "한국어", title: "언어"},
    pl: {name: "Polski", title: "Język"},
    pt: {name: "Português", title: "Idioma"},
    ru: {name: "Русский", title: "Язык"},
    es: {name: "Español", title: "Idioma"},
    sv: {name: "Svenska", title: "Språk"},
    th: {name: "ไทย", title: "ภาษา"},
    tr: {name: "Türkçe", title: "Dil"},
    uk: {name: "Українська", title: "Мова"},
    vi: {name: "Tiếng Việt", title: "Ngôn ngữ"}
};

export const languageInfo = (code) => languages[code] || {name: code.toUpperCase(), title: "Language"};

export default languages;
